export default __webpack_public_path__ + "media/78881bc452672361baff0d09687b1b9d8fcf6035c6c17cf3794b3f693d741ab4.svg";